export const SUBMIT_INITIATED_STATUS = 'INITIATED' as const;
export const SUBMIT_COMPLETED_STATUS = 'COMPLETED' as const;
export type SubmitStatus = null | typeof SUBMIT_INITIATED_STATUS | typeof SUBMIT_COMPLETED_STATUS;
